/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrderAssigneesByRightsQueryVariables = Types.Exact<{
  rights:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
}>

export type WorkOrderAssigneesByRightsQuery = {
  __typename?: 'Query'
  backofficeUsersByRights: Array<
    | {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      }
    | {
        __typename?: 'BackofficeUserLimited'
        id: string
        firstName: string
        lastName: string
      }
  > | null
}

export const WorkOrderAssigneesByRightsDocument = gql`
    query WorkOrderAssigneesByRights($rights: [String!]!) {
  backofficeUsersByRights(rights: $rights) {
    ... on BackofficeUser {
      id
      firstName
      lastName
    }
    ... on BackofficeUserLimited {
      id
      firstName
      lastName
    }
  }
}
    `

/**
 * __useWorkOrderAssigneesByRightsQuery__
 *
 * To run a query within a React component, call `useWorkOrderAssigneesByRightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderAssigneesByRightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderAssigneesByRightsQuery({
 *   variables: {
 *      rights: // value for 'rights'
 *   },
 * });
 */
export function useWorkOrderAssigneesByRightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  > &
    (
      | { variables: WorkOrderAssigneesByRightsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  >(WorkOrderAssigneesByRightsDocument, options)
}
export function useWorkOrderAssigneesByRightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  >(WorkOrderAssigneesByRightsDocument, options)
}
// @ts-ignore
export function useWorkOrderAssigneesByRightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneesByRightsQuery,
  WorkOrderAssigneesByRightsQueryVariables
>
export function useWorkOrderAssigneesByRightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneesByRightsQuery,
        WorkOrderAssigneesByRightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneesByRightsQuery | undefined,
  WorkOrderAssigneesByRightsQueryVariables
>
export function useWorkOrderAssigneesByRightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneesByRightsQuery,
        WorkOrderAssigneesByRightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrderAssigneesByRightsQuery,
    WorkOrderAssigneesByRightsQueryVariables
  >(WorkOrderAssigneesByRightsDocument, options)
}
export type WorkOrderAssigneesByRightsQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesByRightsQuery
>
export type WorkOrderAssigneesByRightsLazyQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesByRightsLazyQuery
>
export type WorkOrderAssigneesByRightsSuspenseQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesByRightsSuspenseQuery
>
export type WorkOrderAssigneesByRightsQueryResult = Apollo.QueryResult<
  WorkOrderAssigneesByRightsQuery,
  WorkOrderAssigneesByRightsQueryVariables
>
